// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — denominations2.classic.js, новая — denominations2.cp.js
import { isCp } from 'libs/design';
import * as classic from './denominations2.classic';
import * as cp from './denominations2.cp';

export const Denominations2 = isCp ? cp.Denominations2 : classic.Denominations2;
